'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _config = require('../config.js');

var Caret = function Caret(options) {
  var defaults = {
    position: 'after',
    color: _config.colors.black,
    size: '6px',
    rotating: true,
    initialRotation: '-45deg',
    endRotation: '45deg'
  };
  var settings = _extends({}, defaults, options);
  var caretStyles = '\n    &::' + settings.position + ' {\n      border-color: ' + settings.color + ';\n      border-image: initial;\n      border-style: solid;\n      border-width: 0px 2px 2px 0px;\n      content: "";\n      padding: ' + settings.size + ';\n      transform: rotate(' + settings.initialRotation + ');\n    }\n  ';

  if (settings.rotating) {
    caretStyles += '\n      &::' + settings.position + ' {\n        transition: 100ms transform 100ms, 100ms top 100ms;\n      }\n\n      &.open::' + settings.position + ' {\n        transform: rotate(' + settings.endRotation + ');\n        transition: 100ms transform, 100ms top;\n      }\n    ';
  }

  return caretStyles;
};

exports.default = Caret;